import State from 'store/State';
import { selectExpertiseWidgetState } from '../selectors';
import { useSelector } from 'react-redux';
import { initialExpertiseConfiguration } from './ExpertiseConfigurationState';
import { useWidgetContext } from 'widgets/WidgetContext';
import { WidgetType } from 'widgets/WidgetType';

export const selectExpertiseConfiguration =
    (widgetType: WidgetType) => (state: State, widgetKey: string) => {
        const expertiseState = selectExpertiseWidgetState(
            state,
            widgetType,
            widgetKey
        );
        return expertiseState && expertiseState.config
            ? expertiseState.config
            : initialExpertiseConfiguration;
    };

export const useExpertiseConfigurationSelector = () => {
    const { widgetType, widgetKey } = useWidgetContext();
    return useSelector((state: State) =>
        selectExpertiseConfiguration(widgetType)(state, widgetKey)
    );
};
